import React from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import "./EditArticlePanel.css";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
import Draggable from "react-draggable";
import EditArticleMetaList from "../EditArticleMetaList/EditArticleMetaList";
import EditArticleContentList from "../EditArticleContentList/EditArticleContentList";
import { withRouter } from "react-router-dom";
import {
  changeArticleModeAction,
  setEditingArticleAction,
  recoverLastEditArticleMetaAction,
  recoverLastEditArticleContentAction,
  createManualItemAction,
  saveArticleAction,
  setLockingIDAction,
  setAllPreviewingItemHidingMode,
  setPreviewOffsetAction,
  saveArticleActionImmediate
} from "../../redux/actions/editArticlePanel";
import EditArticlePreviewList from "../EditArticlePreviewList/EditArticlePreviewList";
import {
  convertAnfApi,
  convertDocxApi,
  confirmArticleApi
} from "../../api/articles";
import {
  ACDTYPE_TEXT,
  ACDTYPE_SEPARATOR,
  ACDTYPE_IMAGE
} from "../../model/ACDTypes";
import { generateUniqueID } from "../../utils/utils";

class EditArticlePanel extends React.Component {
  constructor(props) {
    super(props);

    this.handleResize = this.handleResize.bind(this);
    this.recoverClicked = this.recoverClicked.bind(this);
    this.downloadClicked = this.downloadClicked.bind(this);
    this.arrowClicked = this.arrowClicked.bind(this);
    this.modeClicked = this.modeClicked.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.getPanelPosition = this.getPanelPosition.bind(this);
    this.confirmClicked = this.confirmClicked.bind(this);
    this.createClicked = this.createClicked.bind(this);
    this.onPreviewModeClicked = this.onPreviewModeClicked.bind(this);
    this.previewRef = React.createRef();
    this.messagesEnd = React.createRef();
    this.tocPanelRef = React.createRef();
    this.tocPanelBodyRef = React.createRef();

    this.state = {
      windowHeight: window.innerHeight,
      isDownloading: false,
      isConfirming: false,
      previewMode: null
    };
  }

  componentDidMount() {
    const { article, setEditingArticleAction, components } = this.props;

    setEditingArticleAction({ article, components });

    window.addEventListener("resize", this.handleResize);

    setTimeout(() => {
      this.props.setPreviewOffsetAction({
        previewOffset: 0
      });
    }, 100);
  }

  createClicked(aCDType) {
    let imageID = "";
    if (aCDType === ACDTYPE_IMAGE) {
      imageID = prompt("Please enter Image ID", "");

      if (!imageID) {
        return;
      }

      if (imageID.length < 10) {
        toast.error("Invalid image ID");
        return;
      }
    }

    const newID = generateUniqueID();

    this.props.createManualItemAction({
      newID,
      insertIndex: 0,
      type: aCDType,
      imageID
    });

    this.props.saveArticleAction(this.props.article.id);
    this.props.setLockingIDAction({ lockingID: newID });
  }

  componentDidUpdate(prevProps) {
    const { contentLastAppendTime } = this.props;

    if (contentLastAppendTime !== prevProps.contentLastAppendTime) {
      this.scrollToBottom();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  async confirmClicked() {
    const { article, saveArticleActionImmediate } = this.props;

    this.setState({ isConfirming: true });
    try {
      await saveArticleActionImmediate(article.id);
      await confirmArticleApi(article.id);
      toast.success("Confirm OK");
    } catch (e) {
      toast.error(e.toString());
    }
    this.setState({ isConfirming: false });
  }

  onPreviewModeClicked(mode) {
    const { previewMode } = this.state;
    const { setAllPreviewingItemHidingMode } = this.props;

    if (mode === "invisible") {
      if (previewMode === "invisible") {
        this.setState({ previewMode: null });
        setAllPreviewingItemHidingMode({ mode: null });
      } else {
        this.setState({ previewMode: mode });
        setAllPreviewingItemHidingMode({ mode: mode });
      }
    } else {
      if (previewMode === "highlight") {
        this.setState({ previewMode: null });
        setAllPreviewingItemHidingMode({ mode: null });
      } else {
        this.setState({ previewMode: mode });
        setAllPreviewingItemHidingMode({ mode: mode });
      }
    }
  }

  modeClicked(newMode) {
    const { mode, changeArticleModeAction } = this.props;

    if (mode === newMode) {
      return;
    }

    changeArticleModeAction({ mode: newMode });
  }

  recoverClicked() {
    const {
      recoverLastEditArticleMetaAction,
      recoverLastEditArticleContentAction,
      saveArticleAction,
      article,
      mode
    } = this.props;

    if (mode === "meta") {
      recoverLastEditArticleMetaAction();
    } else if (mode === "edit") {
      recoverLastEditArticleContentAction();
    }

    saveArticleAction(article.id);
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
      } catch (e) {}
    }, 10);
  }

  async downloadClicked(fileType) {
    const { article } = this.props;

    if (fileType === "anf") {
      this.setState({ isDownloading: true });
      try {
        await convertAnfApi(article.id);
      } catch (e) {
        toast.error(e.toString());
      }
      this.setState({ isDownloading: false });
    } else {
      if (this.previewRef != null && this.previewRef.current != null) {
        const htmlText = ReactDOM.findDOMNode(this.previewRef.current)
          .innerHTML;
        this.setState({ isDownloading: true });
        try {
          await convertDocxApi(article.id, htmlText);
        } catch (e) {
          toast.error(e.toString());
        }
        this.setState({ isDownloading: false });
      }
    }
  }

  handleResize() {
    this.setState({
      windowHeight: window.innerHeight
    });
  }

  arrowClicked(right) {
    const { article, issue, history } = this.props;
    const idx = issue.articles.findIndex(
      anArticle => anArticle.id === article.id
    );

    if (idx < 0) {
      return;
    }

    let newIdx =
      (issue.is_left_flip && right) || (!issue.is_left_flip && !right)
        ? idx + 1
        : idx - 1;

    if (newIdx < 0 || newIdx >= issue.articles.length) {
      return;
    }

    const newArticleID = issue.articles[newIdx].id;

    history.push(newArticleID);
  }

  renderSwitch() {
    const { article, issue, mode } = this.props;

    if (mode === "meta") {
      return <EditArticleMetaList articleID={article.id} />;
    } else if (mode === "edit") {
      return (
        <EditArticleContentList
          getPanelPosition={this.getPanelPosition}
          articleID={article.id}
          issue={issue}
        />
      );
    } else {
      return (
        <EditArticlePreviewList
          forwardedRef={this.previewRef}
          article={article}
          issue={issue}
        />
      );
    }
  }

  getPanelPosition() {
    if (this.tocPanelRef == null) {
      return { x: 0, y: 0, scrollTop: 0 };
    }

    let panelRect = this.tocPanelRef.getBoundingClientRect();

    let scrollTop =
      this.tocPanelBodyRef == null ? 0 : this.tocPanelBodyRef.scrollTop;

    return {
      x: panelRect.x,
      y: panelRect.y,
      scrollTop: scrollTop
    };
  }

  render() {
    const { disableRecover, article, mode, issue } = this.props;
    const { previewMode } = this.state;

    const isLoading = article == null;

    let showRecover;
    let showCreate;
    let showPreviewHidingMode;
    let isOld = false;

    if (mode === "meta") {
      showRecover = true;
      showCreate = false;
      showPreviewHidingMode = false;
    } else if (mode === "edit") {
      showRecover = true;
      showCreate = true;
      showPreviewHidingMode = false;
    } else {
      showRecover = false;
      showCreate = false;
      showPreviewHidingMode = true;
    }

    if (article != null) {
      if (
        article.draft != null &&
        article.draft !== "" &&
        article.draft.includes("###")
      ) {
        isOld = true;
      }
    }

    const idx = issue.articles.findIndex(
      anArticle => anArticle.id === article.id
    );

    let disableRight = false;
    let disableLeft = false;

    if (idx >= 0) {
      let newRightIdx;
      let newLeftIdx;

      if (issue.is_left_flip) {
        newRightIdx = idx + 1;
        newLeftIdx = idx - 1;
      } else {
        newRightIdx = idx - 1;
        newLeftIdx = idx + 1;
      }

      if (newRightIdx < 0 || newRightIdx >= issue.articles.length) {
        disableRight = true;
      }

      if (newLeftIdx < 0 || newLeftIdx >= issue.articles.length) {
        disableLeft = true;
      }
    }

    return (
      !isLoading && (
        <Draggable
          handle=".handle"
          cancel=".no_move_panel"
          defaultPosition={{ x: 0, y: 0 }}
        >
          <Card
            ref={el => (this.tocPanelRef = el)}
            bg={isOld ? "danger" : "info"}
            text="white"
            style={{
              width: "650px",
              maxWidth: "95%",
              height: this.state.windowHeight - 10,
              position: "fixed",
              top: "5px",
              right: "5px"
            }}
          >
            <Card.Header className="handle article_card_title">
              <ButtonGroup
                variant="light"
                className="article_btns article_control_btns no_move_panel"
              >
                <Button
                  variant={mode === "meta" ? "success" : "light"}
                  size="sm"
                  className="article_control_btn"
                  onClick={() => this.modeClicked("meta")}
                >
                  <span className="fa fa-info-circle" />
                </Button>

                <Button
                  variant={mode === "edit" ? "success" : "light"}
                  size="sm"
                  className="article_control_btn article_btns no_move_panel"
                  onClick={() => this.modeClicked("edit")}
                >
                  <span className="fa fa-edit" />
                </Button>

                <Button
                  variant={mode === "preview" ? "success" : "light"}
                  size="sm"
                  className="article_control_btn article_btns no_move_panel"
                  onClick={() => this.modeClicked("preview")}
                >
                  <span className="fa fa-eye" />
                </Button>
              </ButtonGroup>

              <ButtonGroup
                variant="dark"
                className="article_btns article_change_btns no_move_panel"
              >
                <Button
                  disabled={disableLeft}
                  variant="dark"
                  size="sm"
                  className="article_change_btn article_btns no_move_panel"
                  onClick={() => this.arrowClicked(false)}
                >
                  <span className="fa fa-arrow-left" />
                </Button>

                <Button
                  disabled={disableRight}
                  variant="dark"
                  size="sm"
                  className="article_change_btn article_btns no_move_panel"
                  onClick={() => this.arrowClicked(true)}
                >
                  <span className="fa fa-arrow-right" />
                </Button>
              </ButtonGroup>
              <Button
                disabled={this.state.isConfirming}
                variant="danger"
                size="sm"
                className="article_change_btn article_btns no_move_panel"
                onClick={this.confirmClicked}
              >
                {this.state.isConfirming ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <span className="fa fa-upload" />
                )}
              </Button>
              <Dropdown
                as="span"
                size="sm"
                className="article_btns no_move_panel"
              >
                <Dropdown.Toggle
                  style={{ margin: 0, marginLeft: "10px" }}
                  size="sm"
                  variant="secondary"
                >
                  {this.state.isDownloading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <span className="fa fa-download" />
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu size="sm">
                  <Dropdown.Item
                    disabled={this.state.isDownloading}
                    onClick={() => this.downloadClicked("anf")}
                  >
                    <span className="fa fa-apple" /> ANF
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {showRecover && (
                <Button
                  variant="primary"
                  size="sm"
                  disabled={disableRecover}
                  className="article_edit_btn article_btns no_move_panel"
                  onClick={this.recoverClicked}
                >
                  <span className="fa fa-undo" />
                </Button>
              )}
              {showCreate && (
                <Dropdown
                  as="span"
                  alignRight
                  size="sm"
                  className="article_edit_btn article_btns no_move_panel"
                >
                  <Dropdown.Toggle
                    style={{ margin: 0, marginLeft: "10px" }}
                    size="sm"
                    variant="warning"
                  >
                    <span className="fa fa-plus" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu size="sm">
                    <Dropdown.Item
                      onClick={() => this.createClicked(ACDTYPE_TEXT)}
                    >
                      Empty Card
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => this.createClicked(ACDTYPE_SEPARATOR)}
                    >
                      Separator
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => this.createClicked(ACDTYPE_IMAGE)}
                    >
                      Image ID
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
              {showPreviewHidingMode && (
                <ButtonGroup
                  className="article_btns article_edit_btn no_move_panel"
                  size="sm"
                >
                  <Button
                    variant={previewMode === "invisible" ? "dark" : "secondary"}
                    className="article_btns no_move_panel article_change_btn"
                    onClick={() => this.onPreviewModeClicked("invisible")}
                  >
                    <span className="fa fa-eye-slash" />
                  </Button>
                  <Button
                    variant={previewMode === "highlight" ? "dark" : "secondary"}
                    className="article_btns no_move_panel article_change_btn"
                    onClick={() => this.onPreviewModeClicked("highlight")}
                  >
                    <span className="fa fa-language" />
                  </Button>
                </ButtonGroup>
              )}
            </Card.Header>
            {!isOld ? (
              <Card.Body
                ref={el => (this.tocPanelBodyRef = el)}
                className="handle edit_toc_list"
                style={{ paddingRight: "5px", paddingLeft: "5px" }}
              >
                {this.renderSwitch()}
                <div
                  ref={el => {
                    this.messagesEnd = el;
                  }}
                />
              </Card.Body>
            ) : (
              <div style={{ textAlign: "center", margin: "20px" }}>
                Please use old warehouse to access this article
              </div>
            )}
          </Card>
        </Draggable>
      )
    );
  }
}

const mapState = state => {
  const { editArticlePanel } = state;
  const {
    mode,
    metaEditHistory,
    contentEditHistory,
    contentLastAppendTime
  } = editArticlePanel;

  let disableRecover = true;

  if (mode === "meta") {
    disableRecover = metaEditHistory.length <= 1;
  } else if (mode === "edit") {
    disableRecover = contentEditHistory.length <= 1;
  }

  return {
    mode,
    disableRecover,
    contentLastAppendTime
  };
};

const mapDispatch = {
  changeArticleModeAction,
  setEditingArticleAction,
  recoverLastEditArticleMetaAction,
  recoverLastEditArticleContentAction,
  createManualItemAction,
  saveArticleAction,
  saveArticleActionImmediate,
  setLockingIDAction,
  setAllPreviewingItemHidingMode,
  setPreviewOffsetAction
};

export default withRouter(
  connect(
    mapState,
    mapDispatch
  )(EditArticlePanel)
);
